var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LayoutSelection"},[_c('label',{attrs:{"for":"layoutSelection"}},[_vm._v("Tabel layout")]),_c('b-form-select',{attrs:{"id":"layoutSelection","disabled":_vm.tableLayoutOptions.length < 2,"options":_vm.tableLayoutOptions},model:{value:(_vm.tableLayout),callback:function ($$v) {_vm.tableLayout=$$v},expression:"tableLayout"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }